import { render } from "./index.vue?vue&type=template&id=604fc1a7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=604fc1a7&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\qfy-all\\qfy-oms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604fc1a7"]])

export default __exports__